import type { ButtonConfig } from '../declare'
import * as Pager from './pager'
import { $consts } from 'src/plugins'

/**
 * 编辑表单配置按钮
 * @param props 
 * @returns 
 */
const PagerButton = (props: { config: ButtonConfig }) => {
  const { BTN_TYPE } = props.config
  switch (BTN_TYPE) {
    // 保存按钮
    case $consts['TABLE/BTN_TYPE_SAVE']:
      return <Pager.SaveBtn config={props.config} />
    // word 打印按钮
    case $consts['TABLE/BTN_TYPE_PRINT']:
      return <Pager.PrintBtn config={props.config} />
    default:
      return <div />
  }
}

export default PagerButton